import * as AppActions from './App';
import * as ChatActions from '../../chat/actions/Chat';
import * as QuestionsActions from './Questions';
import { push } from 'connected-react-router'
import axios from '../../shared/axiosConfig';
import config from '../../shared/config';

export const CompanyActions = {
  SET_ATTRIBUTE: "COMPANY_SET_ATTRIBUTE",
  RESET_STATE: "COMPANY_RESET"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setCompanyAttribute = (key, value) => {
  return {
    type: CompanyActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const resetState = () => {
  return {
    type: CompanyActions.RESET_STATE
  }
}

export const startChatConditional = () => (dispatch, getState) => {
  console.log("Checking if we need to start chat");
  if( getState().company.startChat ) {
    dispatch( loadCompanyChat() );
  }
}

export const loadCompanyChat = () => (dispatch, getState) => {
  console.log("Load company chat");
  if( window.appConfig.preview ) {
    alert('Not available during preview.');
    return;
  }

  dispatch( setCompanyAttribute('startChat', false) );
  let company = getState().company;
  if( company.questions.length > 0) {
    console.log("Open qq dialog");
    dispatch( QuestionsActions.openDialog() );
  } else {
    dispatch( setCompanyAttribute('loaded', false));
    dispatch( redirectToChat() );
  }
}

export const redirectToChat = () =>  (dispatch, getState) => {
  let company = getState().company;
  dispatch( push(`/events/${config.eventSlug}/companies/${company.data.slug}/chat`) );
}


export const returnToEvent = () => (dispatch, getState) => {
  console.log("Back to event page");
  let company = getState().company;
  dispatch( push(`/events/${config.eventSlug}/lobby`) );
}

export const logout = () => (dispatch, getState) => {
  console.log("Clearing peer data");
  let {companyId, eventId} = getState().company;
  axios.delete(`/api/peer`)
    .then( async (res) => {
      console.log("Peer reset completed");
      dispatch( push(`/events/${config.eventSlug}`) );
    })
    .catch( function(err) {
      console.log(err);
    });
}

export const leaveChat = () => (dispatch, getState) => {
  let company = getState().company;
  dispatch( ChatActions.leaveChat() );
  dispatch( push(`/events/${config.eventSlug}/companies/${company.data.slug}`) );
}

export const openMyAccount = () => (dispatch, getState) => {
  dispatch( setCompanyAttribute('accountDialogOpen', true));
}

export const openLoginDialog = () => (dispatch, getState) => {
  dispatch( setCompanyAttribute('loginDialogOpen', true));
}

export const closeLoginDialog = () => (dispatch, getState) => {
  dispatch( setCompanyAttribute('loginDialogOpen', false));
}

export const closeMyAccount = () => (dispatch, getState) => {
  dispatch( setCompanyAttribute('accountDialogOpen', false));
}

export const loadCompanyData = ( eventId, companyId ) => async (dispatch, getState) => {
  console.log("Load company data - ajax");
  dispatch( AppActions.setLoading(true) );
  dispatch( setCompanyAttribute('eventId', eventId));
  dispatch( setCompanyAttribute('companyId', companyId));
  await axios.get(`/api/events/${eventId}/companies/${companyId}`)
    .then((response) => {
      console.log("Company response", response);
      dispatch( setCompanyAttribute('data', response.data.data));
      dispatch( setCompanyAttribute('companyId', response.data.data.id)); // if we passed slug this is a fix
      dispatch( setCompanyAttribute('users', response.data.users));
      dispatch( setCompanyAttribute('benefits', response.data.benefits));
      dispatch( setCompanyAttribute('review_statuses', response.data.review_statuses));
      dispatch( setCompanyAttribute('settings', response.data.settings));
      dispatch( setCompanyAttribute('contents', response.data.contents));
      dispatch( setCompanyAttribute('questions', response.data.questions));
      dispatch( setCompanyAttribute('eventUrl', response.data.event_url));
      dispatch( setCompanyAttribute('loaded', true));
      dispatch( AppActions.setLoading(false) );
    })
    .catch((error) => {
      console.log("Error loading company data", error);
    })
}


